import { store } from 'store';
import { SET_TIPOS_DE_PERSONAS } from 'store/reducers/catalogs';
import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/tipos-de-personas/';

/**
 * GET Tipos de Personas
 * @returns {Promise<Array<object>>}
 */
export const getTiposDePersonas = async (params) => {
  try {
    const { tiposDePersonas } = store.getState().catalogs;
    if (tiposDePersonas?.length) return tiposDePersonas;
    const response = await API.get(baseURI, { params });
    store.dispatch({ type: SET_TIPOS_DE_PERSONAS, payload: response.data });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Persona
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDePersona = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Persona
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDePersona = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Persona
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDePersona = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Persona
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDePersona = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
